

$(function () {
    $('#toggleAdvancedOptions').click(function () {
        if ($('#advancedSearchOptions').is(':hidden')) {
            $('#advancedSearchOptions').slideDown();
            $('#toggleAdvancedOptions').html("Show fewer filter options");
        } else {
            $('#advancedSearchOptions').slideUp();
            $('#toggleAdvancedOptions').html("Show more filter options");
        }
    });
});